import { administratorsLoanOfficersHooks } from 'reducers/slices/administrators/loanOfficersSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';

const useLoanOfficerCreditCard = () => {
  const {
    loanOfficers,
    loadLoanOfficers,
    loadMoreLoanOfficers,
    loadLoanOfficer,
    loanOfficer,
  } = administratorsLoanOfficersHooks.use();

  return {
    isLoanOfficersLoading: useFetchStatus(loanOfficers.loadingStatus).isPending,
    isLoanOfficersIdle: useFetchStatus(loanOfficers.loadingStatus).isIdle,
    loanOfficers: loanOfficers.items,
    meta: loanOfficers.meta,
    isLoanOfficersLoadingMore: useFetchStatus(loanOfficers.moreLoadingStatus).isPending,
    loadLoanOfficers,
    loadMoreLoanOfficers,
    loadLoanOfficer,
    loanOfficer: loanOfficer.item,
    isLoanOfficerLoading: useFetchStatus(loanOfficer.loadingStatus).isPending,
    isLoanOfficerIdle: useFetchStatus(loanOfficer.loadingStatus).isIdle,
    loanOfficerLoadingError: loanOfficer.error,
  };
};

export default useLoanOfficerCreditCard;



// WEBPACK FOOTER //
// ./src/reducers/hooks/administrators/useLoanOfficers.js